<template>
  <!-- Service Name Container -->
  <div class="flex flex-row justify-center my-1.5">
    <div class="md:auto text-center border-b-4 border-[#9d2890]">
      <p class="text-white pb-0 px-2 title">Nasna TV</p>
    </div>
  </div>
  <!-- End of Service Name Container -->
</template>

<script>
export default {};
</script>

<style scoped>
.title {
  font-size: 20px;
}
</style>
